// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlackOutlinedSvg from "@fishx/icons-svg/es/asn/SlackOutlined";
import FishxIcon from '../components/FishxIcon';

var SlackOutlined = function SlackOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SlackOutlinedSvg
  }));
};

SlackOutlined.displayName = 'SlackOutlined';
export default React.forwardRef(SlackOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SlackOutlined.js
// module id = 4137
// module chunks = 0